import { render } from "./GameVersionPanel.vue?vue&type=template&id=1329d960&scoped=true"
import script from "./GameVersionPanel.vue?vue&type=script&lang=js"
export * from "./GameVersionPanel.vue?vue&type=script&lang=js"

import "./GameVersionPanel.vue?vue&type=style&index=0&id=1329d960&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1329d960"]])

export default __exports__